import { render, staticRenderFns } from "./Ocom.vue?vue&type=template&id=b651198c&"
import script from "./Ocom.vue?vue&type=script&lang=js&"
export * from "./Ocom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports